<template>
  <div class="page" :class="$lang == 'en' ? 'page__en' : ''">
    <div class="invite__card">
      <div class="invite__tit">{{ $t('friend_invite_you_to_get_vip') }}</div>
      <div class="invite__letter">
        <div class="invite__lettercontent">
          <div class="invite__fromuser">
            <img
              class="user__headimg"
              :src="
                params.headimg ||
                require('../../assets/image/minip_app_icon_logo@2x.png')
              "
            />
            <div class="user__name">{{ params.username }}</div>
          </div>
          <div class="invite__word">{{ $t('_invite_word') }}</div>
        </div>
        <div class="letter__card">
          <div class="invite__sponsor">{{ $t('elfinbook_yifei') }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="join__item">
        <div class="phone__wapper">
          <div class="phone__prefix" @click="setPhonePrefix">
            +{{ phonePrefix }}
          </div>
          <input
            class="phone__input"
            :placeholder="$t('input_phone')"
            v-model="inputValue"
            type="number"
          />
        </div>
        <div
          class="btn__submit"
          @click="submit"
          :class="inputValue.length > 0 ? '' : 'btn__submit--disable'"
        >
          {{ $t('immediate_get') }}
        </div>
        <div class="rule__link" @click="showRuleBox">
          {{ $t('activity_rule') }}>
        </div>
      </div>
    </div>
    <div class="feature__imglist">
      <img
        :src="
          $lang == 'zh'
            ? require('../../assets/image/invitation_iamge_functions@2x.png')
            : require('../../assets/image/invitation_iamge_functions_en@2x.png')
        "
        class="tit"
      />

      <img
        :src="
          $lang == 'zh'
            ? require('../../assets/image/minip_app_image_scan@2x.png')
            : require('../../assets/image/minip_app_image_scan.png')
        "
        class="featrue__img"
      />
      <img
        :src="
          $lang == 'zh'
            ? require('../../assets/image/minip_app_image_ocr@2x.png')
            : require('../../assets/image/minip_app_image_ocr.png')
        "
        class="featrue__img"
      />
      <img
        :src="
          $lang == 'zh'
            ? require('../../assets/image/minip_app_image_handwritting@2x.png')
            : require('../../assets/image/minip_app_image_handwritting.png')
        "
        class="featrue__img"
      />
    </div>
    <div class="feature__list">
      <img
        :src="
          $lang == 'zh'
            ? require('../../assets/image/invitation_iamge_more@2x.png')
            : require('../../assets/image/invitation_iamge_more_en@2x.png')
        "
        class="tit more-tit"
      />
      <div class="feature__item" v-for="(v, ind) in featureList" :key="ind">
        <img class="feature__icon" :src="v.img" />
        <div class="feature__intr">
          <div class="feature__tit">{{ v.tit }}</div>
          <div class="feature__detail">{{ v.intr }}</div>
        </div>
      </div>
    </div>
    <!--  -->
    <activityRuleBox ref="ruleBox"></activityRuleBox>
  </div>
</template>

<script>
import { qs, show, Toast } from '@/utils/common';
import activityRuleBox from '../../components/activityRuleBox.vue';
import Ajax from '@/utils/Ajax';
const QS = require('qs');
export default {
  components: {
    activityRuleBox
  },
  created() {
    show();
    window.report('InvitePrize_Apply');
    let params = qs.parse(window.location.search);
    if (!params.inviteCode) {
      Toast(this.$t('params_error'));
    } else {
      this.params = params;
    }
    let phonePrefix =
      localStorage.getItem('phonePrefix') || params.zone || '86';
    if (!phonePrefix || phonePrefix == 'undefined') {
      this.phonePrefix = '86';
    } else {
      this.phonePrefix = phonePrefix;
    }
    this.inputValue = localStorage.getItem('invite_phone') || '';
  },
  mounted() {},
  data() {
    return {
      phonePrefix: '',
      inputValue: '',
      params: {
        headimg: '',
        username: ''
      },
      lock: false,
      featureList: [
        {
          tit: this.$t('_share_tit_0'),
          intr: this.$t('_share_intr_0'),
          img: require('../../assets/image/minip_app_icon_pdf@2x.png')
        },
        {
          tit: this.$t('_share_tit_1'),
          intr: this.$t('_share_intr_1'),
          img: require('../../assets/image/minip_app_icon_cloud@2x.png')
        },
        {
          tit: this.$t('_share_tit_2'),
          intr: this.$t('_share_intr_2'),
          img: require('../../assets/image/minip_app_icon_recycle@2x.png')
        },
        {
          tit: this.$t('_share_tit_3'),
          intr: this.$t('_share_intr_3'),
          img: require('../../assets/image/minip_app_icon_search@2x.png')
        },
        {
          tit: this.$t('_share_tit_4'),
          intr: this.$t('_share_intr_4'),
          img: require('../../assets/image/minip_app_icon_folder@2x.png')
        },
        {
          tit: this.$t('_share_tit_5'),
          intr: this.$t('_share_intr_5'),
          img: require('../../assets/image/minip_app_icon_backup@2x.png')
        },
        {
          tit: this.$t('_share_tit_6'),
          intr: this.$t('_share_intr_6'),
          img: require('../../assets/image/minip_app_icon_lock@2x.png')
        }
      ]
    };
  },
  methods: {
    showRuleBox() {
      this.$refs.ruleBox.show();
    },
    setPhonePrefix() {
      localStorage.setItem('invite_phone', this.inputValue);
      window.location.href = './select_phone_prefix?lang=' + this.$lang;
    },
    submit() {
      if (this.lock || this.inputValue.length == 0) {
        return;
      }
      this.lock = true;
      if (!this.phonePrefix || this.phonePrefix == 'undefined') {
        this.phonePrefix = '86';
      }
      Ajax.post('/share/invite?lang=' + this.$lang, {
        inviteCode: this.params.inviteCode,
        prefix: this.phonePrefix,
        username: this.inputValue
      })
        .then((res) => {
          if (res.code == 0) {
            let str = '';
            for (let i in this.params) {
              if (Object.hasOwnProperty.call(this.params, i)) {
                str += '&' + i + '=' + encodeURIComponent(this.params[i]);
              }
            }
            str.replace(/^&/, '');
            let totalPhone = this.phonePrefix + this.inputValue;
            window.report('InvitePrize_GetVip');
            window.location.href = `./invite_success?${str}&expireTime=${
              res.data.expireTime * 1000
            }&phone=${totalPhone}`;
          } else if (res.code == 1000) {
            Toast(res.data);
          } else {
            Toast(this.$t('handleFail'));
          }
          this.lock = false;
        })
        .catch((err) => {
          console.log(err);
          this.lock = false;
        });
    }
  }
};
</script>

<style>
body {
  background: #f4f4f4;
}
</style>
<style lang="scss" scoped>
.page {
}
.invite__card {
  overflow: hidden;
  background: url(~@/assets/image/invitation_iamge_banner2@2x.png) no-repeat 0 0 /
    cover;
}
.invite__tit {
  font-size: 0.28rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.36rem;
}
.invite__letter {
  position: relative;
  margin: 0 auto 0.56rem;
}
.letter__card {
  position: relative;
  margin: 0 auto;
  width: 3.04rem;
  height: 2.62rem;
  background: url(~@/assets/image/invitation_iamge_banner2_letter.png) no-repeat
    0 0 / 100% 100%;
}
.invite__lettercontent {
  padding: 0.12rem 0.2rem 0;
  border-radius: 0.1rem;
  margin: 0.12rem auto -1.3rem;
  width: 2.86rem;
  min-height: 1.47rem;
  background: #fff;
  position: relative;
  z-index: 1;
}
.invite__fromuser {
  overflow: hidden;
  line-height: 0.2rem;
}
.user__headimg {
  float: left;
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 0.2rem;
  margin-right: 0.03rem;
}
.user__name {
  float: left;
  font-size: 0.12rem;
  height: 0.2rem;
}

.invite__word {
  font-size: 0.12rem;
  color: #666;
  line-height: 0.2rem;
  white-space: pre-wrap;
  margin-top: 0.05rem;
}
.invite__sponsor {
  position: absolute;
  top: 1.96rem;
  left: 0;
  width: 100%;
  text-align: center;
}
.content {
  border-radius: 0.12rem 0.12rem 0rem 0rem;
  margin-top: -0.32rem;
}
.join__item {
  background: #fff;
  padding: 0.32rem 0.16rem 0.19rem;
  border-radius: 0.12rem 0.12rem 0rem 0rem;
}
.phone__wapper {
  height: 0.4rem;
  line-height: 0.4rem;
  background: rgba(248, 248, 248, 1);
  border-radius: 0.02rem;
  border: 0.01rem solid rgba(194, 194, 194, 1);
  margin: 0 0 0.24rem;
}
.phone__prefix {
  float: left;
  height: 100%;
  padding: 0 0.11rem;
  background: url(~@/assets/image/login_icon_areacode_copy@2x.png) no-repeat
    right center / 0.08rem 0.08rem;
  min-width: 0.5rem;
  max-width: 0.6rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.14rem;
}
.phone__input {
  float: left;
  height: 100%;
  padding: 0 0.09rem;
  width: 2.83rem;
}
.btn__submit {
  height: 0.44rem;
  line-height: 0.44rem;
  background: rgba(13, 203, 184, 1);
  border-radius: 0.04rem;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
}
.rule__link {
  text-align: center;
  margin-top: 0.2rem;
  color: #666;
}

.feature__imglist {
  overflow: hidden;
  margin-top: 0.12rem;
  background: #fff;
  padding: 0 0.16rem;
}
.tit {
  margin: 0.24rem auto 0.15rem;
  height: 0.21rem;
  display: block;
}
.featrue__img {
  width: 100%;
  height: 1.06rem;
  display: block;
  margin-bottom: 0.16rem;
}
.more-tit {
  margin-bottom: 0;
}

.feature__list {
  overflow: hidden;
  padding: 0 0.16rem 0.34rem;
  background: #fff;
}
.feature__item {
  border-bottom: 0.005rem solid #dedede;
  padding: 0.19rem 0 0.14rem;
  overflow: hidden;
}
.feature__item:last-child {
  border: none;
}
.feature__icon {
  float: left;
  width: 0.48rem;
  height: 0.48rem;
  margin-right: 0.12rem;
}
.feature__intr {
  overflow: hidden;
}
.feature__tit {
  font-weight: bold;
  color: #222;
  margin: 0.03rem 0 0.05rem;
}
.feature__detail {
  color: #666;
  font-size: 0.12rem;
}
.success-alt {
  text-align: center;
  margin-bottom: 0.26rem;
}
.join-phone,
.valid-time {
  height: 0.2rem;
  line-height: 0.2rem;
}

.page__en {
  .invite__letter {
    width: 3.2rem;
    height: 2.75rem;
  }
  .invite__sponsor {
    top: 2.06rem;
  }
  .invite__card {
  }
}

.btn__submit--disable {
  background: rgba(13, 203, 184, 0.4);
}
</style>